// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer that is used for creating/updating Glasgow Comma Scale inside EntryControl model structure.
 * @see #/components/schemas/GlasgowComaScale - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface GlasgowComaScale {
    /**
     * Score for Patient\"s ability to perform eye movement (ranges between 1 to 4).
     *
     */
    eye_opening: number;
    /**
     * Score for Patient\"s ability to perform body movement (ranges between 1 to 6).
     *
     */
    best_motor_response: number;
    /**
     * Score for Patient\"s ability to speak (ranges between 1 to 5).
     *
     */
    best_verbal_response: number;
    /**
     * If the Glasgow Comma Scale is approved by the author.
     *
     */
    is_approved: boolean;
    /**
     * Informs when glasgow-coma-scale took place.
     * @dataFormat date-time
     */
    datetime: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for GlasgowComaScale
 */
export namespace GlasgowComaScale {
    /**
     * GlasgowComaScale Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Score for Patient\"s ability to perform eye movement (ranges between 1 to 4).
         * @type number (`dataFormat` is missing)
         */
        eyeOpening: number;
        /**
         * Score for Patient\"s ability to perform body movement (ranges between 1 to 6).
         * @type number (`dataFormat` is missing)
         */
        bestMotorResponse: number;
        /**
         * Score for Patient\"s ability to speak (ranges between 1 to 5).
         * @type number (`dataFormat` is missing)
         */
        bestVerbalResponse: number;
        /**
         * If the Glasgow Comma Scale is approved by the author.
         * @type boolean (`dataFormat` is missing)
         */
        isApproved: boolean;
        /**
         * Informs when glasgow-coma-scale took place.
         * @dataFormat date-time
         */
        @TransformDate() datetime: Date;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * GlasgowComaScale DTO
     * Transforms GlasgowComaScale model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend GlasgowComaScale model */
        static toModel(obj: GlasgowComaScale): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend GlasgowComaScale model */
        static toApi(obj: Model): GlasgowComaScale {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as GlasgowComaScale;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
